export const GENERIC_COMPLAINT_FORM = 'PrismicGenericTemplateDataBodyComplaintForm';

export interface GenericComplaintFormContent {
  __typename: typeof GENERIC_COMPLAINT_FORM;
}
